import { render, staticRenderFns } from "./OrderPdfSection.vue?vue&type=template&id=d4a82884&scoped=true&"
import script from "./OrderPdfSection.vue?vue&type=script&lang=ts&"
export * from "./OrderPdfSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a82884",
  null
  
)

export default component.exports